import { isEqual } from 'lodash';
import { DynamicFilterResult } from 'streams/dynamicFilters/types';
import {
  ApiDynamicFilter,
  apiDynamicFiltersToDynamicFilterStates,
} from 'filters/dynamicFilters';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  replaceDynamicFilters,
  setDynamicFilterActive,
  setDynamicFilterIncludes,
} from 'streams/dynamicFilters/actions';

interface DynamicFilterApiResult extends ApiDynamicFilter {
  componentIds: string[];
  referenceIds: string[];
}

let dynamicFilterCache: DynamicFilterResult[] = [];

export const loadCachedDynamicFilterResults = (
  results: DynamicFilterApiResult[]
) => {
  dynamicFilterCache = results.map(filter => ({
    id: filter.storedQueryId,
    params: filter.params,
    components: new Set(filter.componentIds),
    references: new Set(filter.referenceIds),
  }));
};

const findFilterWithResult = (filter: ApiDynamicFilter) => {
  return dynamicFilterCache.find(
    cached =>
      cached.id === filter.storedQueryId &&
      isEqual(cached.params, filter.params)
  );
};

export const loadCachedDynamicFilters = (filters: ApiDynamicFilter[]) => {
  const dynamicFilters = filters.map(apiDynamicFiltersToDynamicFilterStates);
  dispatchAction(replaceDynamicFilters(dynamicFilters));

  const filterResults = filters
    .map(findFilterWithResult)
    .filter((filter): filter is DynamicFilterResult => filter !== undefined);

  filterResults.forEach(filter => {
    dispatchAction(setDynamicFilterIncludes(filter));
    dispatchAction(setDynamicFilterActive(filter));
  });
};
